"use strict";
exports.__esModule = true;
var MinMax = /** @class */ (function () {
    function MinMax() {
        this.min = null;
        this.max = null;
    }
    ;
    MinMax.prototype.clone = function () {
        var c = new MinMax();
        c.min = this.min;
        c.max = this.max;
        return c;
    };
    return MinMax;
}());
exports.MinMax = MinMax;
//# sourceMappingURL=min-max.js.map